import { createContext } from 'react';

export type ToastTone = 'success' | 'error' | 'info';

export type ToastInput = {
  title?: string;
  message: string;
  tone?: ToastTone;
  durationMs?: number;
};

export type ToastApi = {
  push: (input: ToastInput) => void;
  success: (message: string, title?: string) => void;
  error: (message: string, title?: string) => void;
  info: (message: string, title?: string) => void;
  dismiss: (id: string) => void;
};

export const ToastContext = createContext<ToastApi | null>(null);
